import CustomLabel from 'Common/CustomLabel/CustomLabel'
import { withFeatureSafe } from 'Common/ErrorBoundaries'
import React, { forwardRef, useImperativeHandle, useRef } from 'react'
// forward ref
const CustomSelect = forwardRef(({
    children,
    wrapperClass,
    label,
    labelClass,
    extraClass,
    required,
    id,
    Icon,
    toolTip,
    iconClass,
    tooltipWidth,
    ...props
}, ref) => {
    const selectRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focus: () => {
            selectRef.current?.focus();
        },
        openDropdown: () => {
            if (selectRef.current) {
                selectRef.current.focus();
                selectRef.current.click();
            }
        }
    }));
    return (
        <div className={`flex flex-col gap-2 w-full ${wrapperClass}`}>
            {label && <CustomLabel toolTip={toolTip} iconClass={iconClass} Icon={Icon} tooltipWidth={tooltipWidth} htmlFor={id} label={label} labelClass={labelClass} required={required} />}
            <select
                ref={selectRef}
                style={{ textOverflow: 'ellipsis' }}
                className={`customInputClass h-9`}
                {...props}
            >
                {children}
            </select>
        </div>
    )
})

export default withFeatureSafe(CustomSelect)